import { render, staticRenderFns } from "./createPayment.vue?vue&type=template&id=477f012f&scoped=true"
import script from "./createPayment.vue?vue&type=script&lang=js"
export * from "./createPayment.vue?vue&type=script&lang=js"
import style0 from "./createPayment.vue?vue&type=style&index=0&id=477f012f&prod&lang=css"
import style1 from "./createPayment.vue?vue&type=style&index=1&id=477f012f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f012f",
  null
  
)

export default component.exports